<template>
  <el-container class="is-vertical">
    <el-container>
      <filters-component></filters-component>
      <div class="el-main" v-on:scroll="scrollHandler">
        <el-input placeholder="Search" v-model="search" class="input-with-select">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div class="library-items">
          <el-row el-row type="flex" :gutter="20" justify="center">
            <el-col v-for="item in libraryItems" :key="item.id" :xs="24" :sm="12" :md="8" :lg="8" :xl="6">
              <library-item :item="item"/>
            </el-col>
          </el-row>
        </div>
        <!--<el-pagination-->
        <!--background-->
        <!--style="text-align: center"-->
        <!--layout="prev, pager, next"-->
        <!--:page-size="9"-->
        <!--:total="1000">-->
        <!--</el-pagination>-->
        <div style="height: 50px" v-loading="true" v-if="isLoading"></div>
        <div class="all-loaded" v-if="allLoaded">All Items Loaded!</div>
      </div>
    </el-container>
  </el-container>
</template>

<script>
  import TabbedLinks from "../components/tabbed-links.vue"
  import LibraryItem from "../components/library-item.vue"
  import FiltersComponent from "../components/filters.vue"

  export default {
    name: 'Library',
    components: {
      TabbedLinks,
      LibraryItem,
      FiltersComponent
    },
    props: {
      filters: null,
    },
    data () {
      return {
        search: "asd",
        filterItems: ['Anatomy', 'Geometry', 'Math', 'History'],
        checkedFilters: ['Anatomy', 'Math'],
        isIndeterminate: true,
        checkAll: false,
        isLoading: true,
        allLoaded: false,
        libraryItems: [
//          {
//            id: 111,
//            name: "Item 1",
//            haveQuiz: true,
//            category: "Anatomy",
//            slides: 10,
//            views: 8888,
//            title: "Title",
//            imageSrc: "http://www.avatarmovie.com/assets/backgrounds/avtr-he-bg-03.jpg",
//            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
//            tags: ["tag1", "tag2", "tag3"],
//          }
        ]
      }
    },
    mounted: function() {
      this.axios.get(this.$store.state.API_URL+'demo?_start=0&_limit=16')
          .then(response => {
            this.libraryItems = response.data;
            this.isLoading = false;
          });
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      scrollHandler(e) {
        if (this.isLoading || this.allLoaded) {
          return;
        }
        if (e.target.scrollTop + e.target.offsetHeight + 400 > e.target.scrollHeight) {
          this.isLoading = true;
          this.axios.get(this.$store.state.API_URL+'demo?_start=' + this.libraryItems.length + '&_limit=8')
              .then(response => {
                console.log(response)
                if (!response.data.length) {
                  this.allLoaded = true;
                  return;
                }
                this.libraryItems = [...this.libraryItems, ...response.data];
                setTimeout(() => {
                  this.isLoading = false;
                }, 200)
              });
        };
      },
      handleCheckAllChange(val) {
        this.checkedFilters = val ? this.filterItems : [];
        this.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.filterItems.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.filterItems.length;
      }
    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ComunityLibrary.vue